import React from 'react';
import { BookOpenIcon, SparklesIcon, ListChecksIcon, WalletIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const features = [{
  num: '01',
  title: 'Ebook Completo e Detalhado',
  description: 'Não é um simples overview. Você terá acesso a um material rico, ilustrado e direto ao ponto, cobrindo tudo que você precisa saber.',
  icon: BookOpenIcon
}, {
  num: '02',
  title: 'As Melhores Técnicas',
  description: 'Aprenda os segredos para velas perfeitas: sem furos, com excelente exalação de aroma e acabamento profissional.',
  icon: SparklesIcon
}, {
  num: '03',
  title: 'Passo a Passo do Zero',
  description: 'Pegamos na sua mão. Desde a escolha da cera e pavio até o momento de embalar e enviar para o seu primeiro cliente.',
  icon: ListChecksIcon
}, {
  num: '04',
  title: 'Gestão e Finanças',
  description: 'Aprenda a precificar corretamente seus produtos para garantir lucro real e construir um negócio sustentável a longo prazo.',
  icon: WalletIcon
}];
export function Features() {
  return <section id="beneficios" className="py-24 bg-brand-cream" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-47">
          <FadeIn data-id="element-48">
            <span className="text-brand-rose font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-49">
              Por que escolher nosso ebook
            </span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-brown" data-id="element-50">
              Tudo que você precisa para começar com segurança
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-51">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-52">
              <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-brand-rose h-full flex flex-col sm:flex-row gap-6 hover:shadow-md transition-shadow" data-id="element-53">
                <div className="flex-shrink-0" data-id="element-54">
                  <div className="w-14 h-14 bg-brand-rose/10 rounded-full flex items-center justify-center text-brand-rose relative" data-id="element-55">
                    <feature.icon className="w-6 h-6 relative z-10" data-id="element-56" />
                    <span className="absolute -top-2 -right-2 text-3xl font-serif font-bold text-brand-blush opacity-50 select-none" data-id="element-57">
                      {feature.num}
                    </span>
                  </div>
                </div>
                <div data-id="element-58">
                  <h3 className="font-serif text-xl font-bold text-brand-brown mb-3" data-id="element-59">
                    {feature.title}
                  </h3>
                  <p className="text-brand-brown/70 leading-relaxed" data-id="element-60">
                    {feature.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}